import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, Link } from 'react-router-dom';
import HomeSkeleton from '../components/HomeSkeleton';
import RightSeleton from '../components/RightSkeleton';
import ChercheRapideSkeleton from "../components/ChercheRapideSkeleton";
import { PopularRequest, ChercheRapideRequest, PlusReserverRequest } from '../Api/HomeApi';
import { BASE_URL } from '../Utils/base_url';
import { AjouteDataRestaurant } from '../Redux/actions/actionDataRestaurant';
import { useDispatch } from 'react-redux';
import Hero from '../components/Hero';
import NoImage from "../Image/no-image.jpg";
import { AfficheHero } from '../Api/HomeApi';
import db from '../db';

import '../Css/home.css';

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [loadingChercheRapide, setLoadingChercheRapide] = useState(false);
  const [loadingPlusReserver, setLoadingPlusReserver] = useState(false);


  const [imageUrl, setImageUrl] = useState('');
  const [imageLoad, setImageLoad] = useState(false);



  const [popular, setPopular] = useState([]);
  const [plusReserver, setPlusReserver] = useState([]);

  const [filterRechercheRapide, setFilterRechercheRapide] = useState([]);
  const [rechercheRapide, setRechercheRapide] = useState([]);
  const [plusReserverCritere, setPlusReserverCritere] = useState([]);

  const [chercheActif, setChercheActif] = useState("");

  let location = useLocation();
  let dispatch = useDispatch();



  useEffect(() => {
    db.monTableau.clear();
    setImageLoad(true);
    AfficheHero().then(function (response) {
      setImageUrl(response.data.donner[0].imageUrl);
      localStorage.setItem('urlHero', response.data.donner[0].imageUrl);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setImageLoad(false);
    });

  }, []);


  useEffect(() => {
    setLoading(true);
    PopularRequest().then(function (response) {
      setPopular(response.data.donner?.filter((el) => el.photos.length !== 0 && el.informations.length !== 0));
      dispatch(AjouteDataRestaurant(response.data.donner));
      setPlusReserver(response.data.donner?.filter((el) => el.photos.length !== 0 && el.informations.length !== 0));
      setFilterRechercheRapide(response.data.donner?.filter((el) => el.photos.length !== 0 && el.informations.length !== 0));
      db.monTableau.bulkPut(response.data.donner)
        .catch((error) => {
          console.error('Erreur lors de la sauvegarde des données dans Dexie :', error);
        });
      localStorage.setItem('dataRestaurant', 'dataRestaurant');
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoading(false);
    });


  }, [dispatch]);







  useEffect(() => {
    setLoadingPlusReserver(true);
    PlusReserverRequest().then(function (response) {
      setPlusReserverCritere(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadingPlusReserver(false);
    });
  }, []);

  useEffect(() => {
    setLoadingChercheRapide(true);
    ChercheRapideRequest().then(function (response) {
      setRechercheRapide(response.data.donner);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadingChercheRapide(false);
    });


  }, []);






  const viewPromotion = (promo) => {
    const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = promo.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return (<label>-50%</label>);
    } else if (existePromo40) {
      return (<label>-40%</label>);
    } else if (existePromo30) {
      return (<label>-30%</label>);
    } else if (existePromo20) {
      return (<label>-20%</label>);
    } else if (existePromo10) {
      return (<label>-10%</label>);
    } else if (existePromoSpecial) {
      return (<label>Spécial</label>);

    } else {
      return (<p>Pas de promotion ...</p>);
    }


  }


  const viewPromotionFilter = (promo) => {
    const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");

    if (existePromo50) {
      return 50;
    } else if (existePromo40) {
      return 40;
    } else if (existePromo30) {
      return 30;
    } else if (existePromo20) {
      return 20;
    } else if (existePromo10) {
      return 10;
    }

  }

  const safeParseFloat = (str) => {
    const value = Number.parseFloat(str);

    return Number.isNaN(value) ? 0 : value;

  };


  const valueNotes = (notes) => {
    const note = safeParseFloat(notes.reduce(
      (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
      0
    ) / notes.length);

    return note;
  }


  const handleRechercheRapideVille = (critere, titre) => {
    const valueFilter = filterRechercheRapide?.filter((el) => el.ville === critere);
    setPopular(valueFilter);

    setChercheActif(titre);
  }

  const handleRechercheRapideCuisine = (critere, titre) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      el.typeCuisines.forEach((element) => {
        if (element.libelle === critere) {
          valueFilter.push(el)
        }
      });
    });
    setPopular(valueFilter);
    setChercheActif(titre);
  }

  const handleRechercheRapideEnfant = (critere) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      el.cadreAmbiances.forEach((element) => {
        if (element.libelle === critere) {
          valueFilter.push(el);
        }
      });
    });
    setPopular(valueFilter);
    setChercheActif(critere);
  }

  const handleRecherchePlusReserver = (critere) => {
    const sortedPopular = [...filterRechercheRapide].sort((a, b) => a.reservations.length < b.reservations.length ? 1 : -1);
    setPopular(sortedPopular);
    setChercheActif(critere);
  }


  const handleRechercheMeuilleurPromo = (critere) => {
    const sortedPopular = [...filterRechercheRapide].sort((a, b) => viewPromotionFilter(a.promotions) < viewPromotionFilter(b.promotions) ? 1 : -1);
    setPopular(sortedPopular);
    setChercheActif(critere);
  }


  const handleRechercheMeuilleurNote = (critere) => {
    const sortedPopular = [...filterRechercheRapide].sort((a, b) => parseFloat(valueNotes(a.notes)) < parseFloat(valueNotes(b.notes)) ? 1 : -1);
    setPopular(sortedPopular);
    setChercheActif(critere);
  }


  const handleRechercheNouveauVenus = (critere) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      if (el.reservations.length < 3) {
        valueFilter.push(el);
      }
    });
    setPopular(valueFilter);
    setChercheActif(critere);
  }

  const handleRechercheRooftop = (critere) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      el.cadreAmbiances.forEach((element) => {
        if (element.libelle === critere) {
          valueFilter.push(el);
        }
      });
    });
    setPopular(valueFilter);
    setChercheActif(critere);
  }


  const handleRecherchePlusPersonne = (critere) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      if (el.nombrePersonne > 10) {
        valueFilter.push(el);
      }
    });
    setPopular(valueFilter);
    setChercheActif(critere);
  }


  const handleRechercheFamille = (critere) => {
    const valueFilter = [];
    filterRechercheRapide.forEach((el) => {
      el.cadreAmbiances.forEach((element) => {
        if (element.libelle === "En famille") {
          valueFilter.push(el);
        }
      });
    });
    setPopular(valueFilter);
    setChercheActif(critere);
  }

  const viewRecherche = (element, index) => {
    if (element.titre === "Ville" || element.titre === "Type de cuisine") {
      if (element.titre === "Ville") {
        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheRapideVille(element.critere, element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre} [ {element.critere} ]</h3>
            </div>
          </div>
        )
      } else {
        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheRapideCuisine(element.critere, element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre} [ {element.critere} ]</h3>
            </div>
          </div>
        )
      }

    } else {

      if (element.titre === "Enfants bienvenus") {
        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheRapideEnfant(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Les plus réservés") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRecherchePlusReserver(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Meilleures promo") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheMeuilleurPromo(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Mieux notés") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheMeuilleurNote(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Nouveaux venus") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheNouveauVenus(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Rooftop") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheRooftop(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else if (element.titre === "Spécial groupe +10 pers") {

        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRecherchePlusPersonne(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      } else {
        return (
          <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4' key={index}>
            <div className={element.titre === chercheActif ? 'item_recherche actif' : 'item_recherche'} onClick={() => handleRechercheFamille(element.titre)}>
              <i className='fa fa-tag'></i>
              <h3>{element.titre}</h3>
            </div>
          </div>
        )
      }

    }

  }




  const viewPlusReserver = () => {

    if (plusReserverCritere[0]?.titre === "Ville") {
      const dataVille = plusReserver?.filter((el) => el.ville === plusReserverCritere[0]?.libelle);
      const sorted = [...dataVille]?.sort((a, b) => a.reservations.length < b.reservations.length ? 1 : -1);
      return (sorted?.map((val, index) => {
        if (index < 9) {
          return (
            <div
              className='items' key={index}>
              <div className='box shadow'>
                <div className='images '>
                  <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                    <div className='img'>
                      <img src={val.photos.length === 0 ? NoImage : BASE_URL + val.photos[0]?.urlPhoto} alt='logo restaurant' />
                    </div>
                  </Link>
                  <div className='category'>
                    <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'><span>{val.nomRestaurant}</span></Link>
                  </div>
                </div>
                <div className='legend'>
                  <h3 className='title'>{val.typeCuisines.length === 0 ? 'Restaurant' : val.typeCuisines[0]?.libelle}</h3>
                  {/* <h3 className='title'>{val.title.slice(0, 40)}...</h3> */}
                  <div className='sub_footer'>
                    <div>
                      <i className='fa fa-bookmark'></i>
                      <label>PM : {val.prixMoyenne.length === 0 ? '000' : val.prixMoyenne[0]?.prix} Ar</label>
                    </div>
                    {val.promotions.length === 0 ? '' :
                      <div className="reduction">
                        <i className='fa fa-bullhorn'></i>
                        {viewPromotion(val.promotions)}
                      </div>}
                  </div>
                  <div className='footer_card'>
                    {val.quartiers ?
                      <div className='adresse'>
                        <i className='fa fa-map-marker'></i>
                        <label>{val?.quartiers[0]?.libelle}</label>
                      </div>
                      : ''}

                    <div className='details'>
                      <i className='fa fa-building'></i>
                      <Link to={`/restoPage/${val.id}`} title="page restaurant"><label>Détails</label></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        } else {
          return '';
        }

      }))

    } else {
      const dataCuisine = [];
      plusReserver.forEach((el) => {
        return el.typeCuisines.forEach((element) => {
          if (element.libelle === plusReserverCritere[0]?.libelle) {
            return dataCuisine.push(el);
          }
        });
      });
      const sorted = [...dataCuisine].sort((a, b) => a.reservations.length < b.reservations.length ? 1 : -1);
      return (sorted?.map((val, index) => {
        if (index < 9) {
          return (
            <div
              className='items' key={index}>
              <div className='box shadow'>
                <div className='images '>
                  <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                    <div className='img'>
                      <img src={val.photos.length === 0 ? NoImage : BASE_URL + val.photos[0]?.urlPhoto} alt='logo restaurant' />
                    </div>
                  </Link>
                  <div className='category'>
                    <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'><span>{val.nomRestaurant}</span></Link>
                  </div>
                </div>
                <div className='legend'>
                  <h3 className='title'>{val.typeCuisines.length === 0 ? 'Restaurant' : val.typeCuisines[0]?.libelle}</h3>
                  {/* <h3 className='title'>{val.title.slice(0, 40)}...</h3> */}
                  <div className='sub_footer'>
                    <div>
                      <i className='fa fa-bookmark'></i>
                      <label>PM : {val.prixMoyenne.length === 0 ? '000' : val.prixMoyenne[0]?.prix} Ar</label>
                    </div>
                    {val.promotions.length === 0 ? '' :
                      <div className="reduction">
                        <i className='fa fa-bullhorn'></i>
                        {viewPromotion(val.promotions)}
                      </div>}
                  </div>
                  <div className='footer_card'>
                    {val.quartiers ?
                      <div className='adresse'>
                        <i className='fa fa-map-marker'></i>
                        <label>{val?.quartiers[0]?.libelle}</label>
                      </div>
                      : ''}
                    <div className='details'>
                      <i className='fa fa-building'></i>
                      <Link to={`/restoPage/${val.id}`} title="page restaurant"><label>Détails</label></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        } else {
          return '';
        }

      }))
    }

  }


  const viewPopular = () => {

    const sortedPopular = [...popular]?.sort((a, b) => a.reservations.length < b.reservations.length ? 1 : -1);

    return (
      sortedPopular && sortedPopular?.map((val, index) => {
        if (index < 10) {
          if (index < 6) {
            return (
              <div
                className='col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4' key={index}>
                <div className='items'>
                  <div className='box shadow'>
                    <div className='images'>
                      <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                        <div className='img'>
                          <img src={val.photos.length === 0 ? NoImage : BASE_URL + val.photos[0]?.urlPhoto} alt='logo restaurant' />
                        </div>
                      </Link>
                      <div className='category'>
                        <span>{val.typeCuisines.length === 0 ? 'Restaurant' : val.typeCuisines[0]?.libelle}</span>
                      </div>
                    </div>
                    <div className='legend'>
                      <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                        <h3 className='title text-center'>{val.nomRestaurant}</h3>
                      </Link>
                      {/* <h3 className='title'>{val.title.slice(0, 100)}...</h3> */}
                      <div className='sub_footer'>
                        <div>
                          <i className='fa fa-bookmark'></i>
                          <label>PM : {val.prixMoyenne.length === 0 ? '000' : val.prixMoyenne[0]?.prix} Ar</label>
                        </div>
                        {val.promotions.length === 0 ? '' :
                          <div className="reduction">
                            <i className='fa fa-bullhorn'></i>
                            {viewPromotion(val.promotions)}
                          </div>}
                      </div>
                      <div className='footer_card'>
                        {val.quartiers ?
                          <div className='adresse'>
                            <i className='fa fa-map-marker'></i>
                            <label>{val?.quartiers[0]?.libelle}</label>
                          </div>
                          : ''}
                        <div className='details'>
                          <i className='fa fa-building'></i>
                          <Link to={`/restoPage/${val.id}`} title="page restaurant"><label>Détails</label></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div
                className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" key={index}>
                <div className='card_popular shadow'>
                  <div className='image_card'>
                    <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                      <div className='img'>
                        <img src={val.photos.length === 0 ? NoImage : BASE_URL + val.photos[0]?.urlPhoto} alt='logo restaurant' />
                      </div>
                    </Link>
                    <div className='legend'>
                      <div>
                        <div className='category'>
                          <span>{val.typeCuisines.length === 0 ? 'Restaurant' : val.typeCuisines[0]?.libelle}</span>
                        </div>
                      </div>
                      <div className='legend_content'>

                        {/* <h3 className='title'>{val.title.slice(0, 40)}...</h3> */}
                        <div className='sub_footer'>
                          <Link to={`/restoPage/${val.id}`} title="page restaurant" className='lien'>
                            <h3 className='title'>{val.nomRestaurant}</h3>
                          </Link>
                          <div>
                            <i className='fa fa-bookmark'></i>
                            <label>PM : {val.prixMoyenne.length === 0 ? '000' : val.prixMoyenne[0]?.prix} Ar</label>
                          </div>
                          {val.promotions.length === 0 ? '' :
                            <div className="reduction">
                              <i className='fa fa-bullhorn'></i>
                              {viewPromotion(val.promotions)}
                            </div>}
                        </div>
                        <div className='footer_card'>
                          {val.quartiers ?
                            <div className='adresse'>
                              <i className='fa fa-map-marker'></i>
                              <label>{val?.quartiers[0]?.libelle}</label>
                            </div>
                            : ''}
                          <div className='details'>
                            <i className='fa fa-building'></i>
                            <Link to={`/restoPage/${val.id}`} title="page restaurant"><label>Détails</label></Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            );
          }

        } else {
          return '';
        }

      })
    )
  }

  return (
    <div>
      <Helmet>
        <title>Accueil</title>
        <meta name='description' content='Accueil.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className="home">
        <div className='mainContent'>
          <Hero ou="" qoui="" date="" heure="" personne="" imageLoad={imageLoad} imageUrl={imageUrl} />
          <section className='popular'>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8'>
                <div className='heading_une'>
                  <h2>Popular</h2>
                </div>
                <div className='la_une'>

                  {loading === true ? <HomeSkeleton /> :
                    <div layout className='row'>
                      {popular.length !== 0 ?
                        viewPopular()
                        : <p>Pas de restaurant disponible ...</p>}
                    </div>

                  }

                  <div className='heading_recherche'>
                    <h2>Recherche rapide par :</h2>
                  </div>
                  {loadingChercheRapide === true ? <ChercheRapideSkeleton /> : <div className='liste_recherche'>
                    <div className='row'>
                      {rechercheRapide && rechercheRapide?.map((element, index) => viewRecherche(element, index))}
                    </div>
                  </div>}

                </div>

              </div>
              <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                <div className='heading_reserver'>
                  {plusReserverCritere[0]?.titre === "Ville" ? <h2>Restaurants les plus réservés {plusReserverCritere[0]?.libelle}</h2> :
                    <h2>Restaurants les plus réservés Cuisine {plusReserverCritere[0]?.libelle}</h2>}
                </div>

                {loadingPlusReserver === true ?
                  <RightSeleton /> : <div className='reserver'>
                    {viewPlusReserver()}
                  </div>}

              </div>
            </div>
          </section>
        </div>

        <p className="version">Version 1</p>
      </div>
    </div>
  )
}

export default Home